import { render, staticRenderFns } from "./render-video.vue?vue&type=template&id=95f89120&"
import script from "./render-video.vue?vue&type=script&lang=ts&"
export * from "./render-video.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports